import styled from "styled-components";
import { CONTENT_WIDTH, media, PAGE_GUTTER } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const InnerContainer = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 60px;
  box-sizing: border-box;
  padding-left: ${PAGE_GUTTER.desktop}px;
  padding-right: ${PAGE_GUTTER.desktop}px;

  ${media.downTablet`
    width: 100%;
    margin-top: 40px;
    padding-left: ${PAGE_GUTTER.tablet}px;
    padding-right: ${PAGE_GUTTER.tablet}px;
  `}

  ${media.downMobile`
    padding-left: ${PAGE_GUTTER.mobile}px;
    padding-right: ${PAGE_GUTTER.mobile}px;
  `}
`;

export const BannerWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const MainBanner = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
`;

export const MainHeading = styled.h2`
  margin: 0px;
  color: var(--04, #010002);
  font-family: Poppins;
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;

  ${media.downTablet`
    font-size: 28px;
    line-height: 36px;
  `}

  ${media.downMobile`
    font-size: 24px;
    line-height: 32px;
  `}
`;

export const MainSubHeading = styled.h3`
  margin: 0px;
  color: #000;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 17.6px;
  letter-spacing: -0.04px;
  text-transform: capitalize;
  padding-top: 30px;
  padding-bottom: 30px;

  ${media.downTablet`
    font-size: 18px;
    line-height: 24px;
    padding-top: 15px;
    padding-bottom: 15px;
  `}

  ${media.downMobile`
    font-size: 16px;
    padding-top: 12px;
    padding-bottom: 12px;
  `}
`;
